// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container--uc8Ks {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.style__header--UcVZg {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.style__headerInfo--xSziN {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: flex-start;
  align-items: flex-start;
}
.style__headerSessionName--ctx91 {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  align-items: center;
  justify-content: start;
  align-content: center;
}
.style__icon--EH9ew {
  color: #7d8287;
  cursor: pointer;
}
.style__forceStopButton--qIo4i {
  background-color: #d72a1d;
}
.style__content--QUCE0 {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  justify-content: stretch;
  align-items: flex-start;
  align-self: stretch;
  height: 100%;
  overflow: auto;
}
.style__content--QUCE0 > div {
  flex: 1;
  min-width: 0;
}
.style__tagContainer--njjSg {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
.style__avatar--yISm5 img {
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
}
.style__status--HORuB {
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.style__inProgressItem--RnQjK {
  background-color: #f9f5ff;
  padding: 0.4rem;
  color: #0070cc;
}
.style__caretDown--txhsd {
  transform: rotate(180deg);
}
.style__bookmarkItem--YmA_3 {
  background-color: #f9f5ff;
  color: #0070cc;
}
.style__errorItem--cRNCI {
  background-color: #fff3f0;
  color: #d72a1d;
}
.style__completeItem--MCbZL {
  background-color: #eaffe9;
  padding: 0.375rem;
  color: #00a751;
}
.style__defaultItemIcon--r5XOQ {
  border-radius: 50%;
  background-color: #e3e4e8;
  height: 2rem;
  width: 2rem;
  color: #0c0d0d;
  display: flex;
  justify-content: center;
  align-items: center;
}
.style__box--nPfbH {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.style__rating--FjBtv {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 1.5rem;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem 0.25rem 0.375rem;
  border-radius: 1rem;
  color: #626a65;
  background-color: #f1f4f2;
}
.style__rating--FjBtv svg {
  fill: #626a65;
}
.style__highRating--am6nc {
  background-color: #eaffe9;
  color: #00a751;
}
.style__highRating--am6nc > svg {
  fill: #00a751;
}
.style__mediumRating--J7YnD {
  background-color: #fffae5;
  color: #e5b300;
}
.style__mediumRating--J7YnD > svg {
  fill: #e5b300;
}
.style__lowRating--J3lp4 {
  background-color: #fff3f0;
  color: #d72a1d;
}
.style__lowRating--J3lp4 > svg {
  fill: #d72a1d;
}
.style__tooltip--fPFPr > * {
  display: flex;
  align-items: center;
}
.style__lessonRow--OXwXF {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  align-items: flex-start;
}
.style__lessonRow--OXwXF > div {
  flex: 1;
  min-width: 0;
}
.style__incidentsBox--CoXQx {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border: 3px solid #e3e8e5;
  border-radius: 0.5rem;
  padding: 1rem;
  gap: 0.75rem;
  height: fit-content;
}
.style__infoBoxHeader--EjSI6 {
  color: #18191b;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.style__emptyIncidents--TRuuC {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  color: #626a65;
}
.style__incidentsList--gfCfG {
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-y: auto;
}
.style__incidentItem--bKCXU {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  gap: 1rem;
}
.style__incidentInfo--AV4Ik {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.style__incidentType--QZlss {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
}
.style__incidentDetails--M7s1d {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.style__incidentDetails--M7s1d span:first-child {
  color: #0c0d0d;
}
.style__incidentDetails--M7s1d span:last-child {
  color: #626a65;
}
.style__incidentThumbnail--HGZia {
  position: relative;
  width: 80px;
  height: 50px;
  border-radius: 0.5rem;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  background-color: #e3e8e5;
}
.style__incidentThumbnail--HGZia img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.style__incidentThumbnail--HGZia:hover .style__playOverlay--JTu8v {
  opacity: 1;
}
.style__thumbnailPlaceholder--fQ6Vy {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #626a65;
}
.style__playOverlay--JTu8v {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  color: #fff;
}
.style__videoDialogOverlay--YdybS {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.style__videoDialog--wu3Qs {
  background-color: #fff;
  border-radius: 1rem;
  max-width: 1100px;
  width: 95%;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.style__videoDialogHeader--F5RRG {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e3e8e5;
}
.style__closeIcon--_dKb2 {
  cursor: pointer;
  color: #626a65;
}
.style__closeIcon--_dKb2:hover {
  color: #0c0d0d;
}
.style__videoDialogContent--OQfqB {
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.style__videoPlayer--P1UBR {
  width: 100%;
  max-height: 75vh;
  border-radius: 0.5rem;
}
.style__videoDialogWarning--XzvmG {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  background-color: #fffae5;
  color: #e5b300;
}
.style__videoDialogWarning--XzvmG svg {
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DriveDetailsPage/style.less"],"names":[],"mappings":"AAGA;EAEI,aAAA;EACA,sBAAA;EACA,WAAA;AAHJ;AADA;EAQI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAJJ;AARA;EAgBI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,uBAAA;AALJ;AAfA;EAwBI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;AANJ;AAvBA;EAiCI,cAAA;EACA,eAAA;AAPJ;AA3BA;EAsCI,yBAAA;AARJ;AA9BA;EA0CI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AATJ;AAxCA;EAqDM,OAAA;EACA,YAAA;AAVN;AA5CA;EA2DI,aAAA;EACA,mBAAA;EACA,WAAA;AAZJ;AAjDA;EAkEM,kBAAA;EACA,YAAA;EACA,WAAA;AAdN;AAtDA;EAyEI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAhBJ;AA9DA;EAkFI,yBAAA;EACA,eAAA;EACA,cAAA;AAjBJ;AAnEA;EAwFI,yBAAA;AAlBJ;AAtEA;EA4FI,yBAAA;EACA,cAAA;AAnBJ;AA1EA;EAiGI,yBAAA;EACA,cAAA;AApBJ;AA9EA;EAsGI,yBAAA;EACA,iBAAA;EACA,cAAA;AArBJ;AAnFA;EA4GI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAtBJ;AA7FA;EAuHI,aAAA;EACA,sBAAA;EACA,SAAA;AAvBJ;AAlGA;EA6HI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AAxBJ;AA9GA;EAyIM,aAAA;AAxBN;AAjHA;EA8II,yBAAA;EACA,cAAA;AA1BJ;AArHA;EAkJM,aAAA;AA1BN;AAxHA;EAuJI,yBAAA;EACA,cAAA;AA5BJ;AA5HA;EA2JM,aAAA;AA5BN;AA/HA;EAgKI,yBAAA;EACA,cAAA;AA9BJ;AAnIA;EAoKM,aAAA;AA9BN;AAtIA;EA0KM,aAAA;EACA,mBAAA;AAjCN;AA1IA;EAgLI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;AAnCJ;AAhJA;EAuLM,OAAA;EACA,YAAA;AApCN;AApJA;EA6LI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;AAtCJ;AA9JA;EAwMI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAvCJ;AApKA;EA+MI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAxCJ;AA3KA;EAuNI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AAzCJ;AAjLA;EA8NI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AA1CJ;AAzLA;EAuOI,aAAA;EACA,sBAAA;EACA,YAAA;AA3CJ;AA9LA;EA6OI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AA5CJ;AApMA;EAoPI,aAAA;EACA,sBAAA;EACA,YAAA;AA7CJ;AAzMA;EAyPM,cAAA;AA7CN;AA5MA;EA6PM,cAAA;AA9CN;AA/MA;EAkQI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AAhDJ;AAzNA;EA4QM,WAAA;EACA,YAAA;EACA,iBAAA;AAhDN;AAmDI;EAEI,UAAA;AAlDR;AAjOA;EAyRI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AArDJ;AAzOA;EAkSI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;EACA,WAAA;AAtDJ;AAvPA;EAiTI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAvDJ;AAnQA;EA8TI,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAxDJ;AA7QA;EAyUI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AAzDJ;AArRA;EAkVI,eAAA;EACA,cAAA;AA1DJ;AA4DI;EACE,cAAA;AA1DN;AA5RA;EA2VI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA5DJ;AAlSA;EAkWI,WAAA;EACA,gBAAA;EACA,qBAAA;AA7DJ;AAvSA;EAyWI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,cAAA;AA/DJ;AAhTA;EAkXM,cAAA;AA/DN","sourcesContent":["@import '@yaak/components/src/colors';\n@import '@yaak/components/src/spacing';\n\n:local {\n  .container {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-150;\n  }\n\n  .header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n  }\n\n  .headerInfo {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n\n  .headerSessionName {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-75;\n    align-items: center;\n    justify-content: start;\n    align-content: center;\n  }\n\n  .icon {\n    color: @color-asphalt-grey-050;\n    cursor: pointer;\n  }\n\n  .forceStopButton {\n    background-color: @color-red-050;\n  }\n\n  .content {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-150;\n    justify-content: stretch;\n    align-items: flex-start;\n    align-self: stretch;\n    height: 100%;\n    overflow: auto;\n\n    // All info boxes get equal width and fill available space\n    > div {\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  .tagContainer {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-50;\n  }\n\n  .avatar {\n    img {\n      border-radius: 50%;\n      height: @spacing-200;\n      width: @spacing-200;\n    }\n  }\n\n  .status {\n    border-radius: 50%;\n    height: @spacing-200;\n    width: @spacing-200;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .inProgressItem {\n    background-color: @color-indigo-099;\n    padding: 0.4rem;\n    color: @color-blue-050;\n  }\n\n  .caretDown {\n    transform: rotate(180deg);\n  }\n\n  .bookmarkItem {\n    background-color: @color-indigo-099;\n    color: @color-blue-050;\n  }\n\n  .errorItem {\n    background-color: @color-red-099;\n    color: @color-red-050;\n  }\n\n  .completeItem {\n    background-color: @color-green-099;\n    padding: 0.375rem;\n    color: @color-green-060;\n  }\n\n  .defaultItemIcon {\n    border-radius: 50%;\n    background-color: @color-asphalt-grey-090;\n    height: @spacing-200;\n    width: @spacing-200;\n    color: @color-pewter-grey-005;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .box {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n  }\n\n  .rating {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    height: @spacing-150;\n    gap: @spacing-25;\n    padding: @spacing-25 @spacing-50 @spacing-25 0.375rem;\n    border-radius: @spacing-100;\n    color: @color-pewter-grey-040;\n    background-color: @color-pewter-grey-095;\n\n    svg {\n      fill: @color-pewter-grey-040;\n    }\n  }\n\n  .highRating {\n    background-color: @color-green-099;\n    color: @color-green-060;\n\n    > svg {\n      fill: @color-green-060;\n    }\n  }\n\n  .mediumRating {\n    background-color: @color-yellow-099;\n    color: @color-yellow-050;\n\n    > svg {\n      fill: @color-yellow-050;\n    }\n  }\n\n  .lowRating {\n    background-color: @color-red-099;\n    color: @color-red-050;\n\n    > svg {\n      fill: @color-red-050;\n    }\n  }\n\n  .tooltip {\n    > * {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  .lessonRow {\n    display: flex;\n    flex-direction: row;\n    gap: @spacing-150;\n    align-items: flex-start;\n\n    // Both components fill available space equally\n    > div {\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  .incidentsBox {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    border: 3px solid @color-pewter-grey-090;\n    border-radius: @spacing-50;\n    padding: @spacing-100;\n    gap: @spacing-75;\n    height: fit-content;\n  }\n\n  .infoBoxHeader {\n    color: @color-asphalt-grey-010;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .emptyIncidents {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: @spacing-150;\n    color: @color-pewter-grey-040;\n  }\n\n  .incidentsList {\n    display: flex;\n    flex-direction: column;\n    max-height: 400px;\n    overflow-y: auto;\n  }\n\n  .incidentItem {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: @spacing-75 0;\n    gap: @spacing-100;\n  }\n\n  .incidentInfo {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-25;\n  }\n\n  .incidentType {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: @spacing-75;\n  }\n\n  .incidentDetails {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-25;\n\n    span:first-child {\n      color: @color-pewter-grey-005;\n    }\n\n    span:last-child {\n      color: @color-pewter-grey-040;\n    }\n  }\n\n  .incidentThumbnail {\n    position: relative;\n    width: 80px;\n    height: 50px;\n    border-radius: @spacing-50;\n    overflow: hidden;\n    cursor: pointer;\n    flex-shrink: 0;\n    background-color: @color-pewter-grey-090;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    &:hover {\n      .playOverlay {\n        opacity: 1;\n      }\n    }\n  }\n\n  .thumbnailPlaceholder {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: @color-pewter-grey-040;\n  }\n\n  .playOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    opacity: 0.7;\n    transition: opacity 0.2s ease;\n    color: @color-white;\n  }\n\n  .videoDialogOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n\n  .videoDialog {\n    background-color: @color-white;\n    border-radius: @spacing-100;\n    max-width: 1100px;\n    width: 95%;\n    max-height: 95vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .videoDialogHeader {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: @spacing-100 @spacing-150;\n    border-bottom: 1px solid @color-pewter-grey-090;\n  }\n\n  .closeIcon {\n    cursor: pointer;\n    color: @color-pewter-grey-040;\n\n    &:hover {\n      color: @color-pewter-grey-005;\n    }\n  }\n\n  .videoDialogContent {\n    padding: @spacing-100;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .videoPlayer {\n    width: 100%;\n    max-height: 75vh;\n    border-radius: @spacing-50;\n  }\n\n\n  .videoDialogWarning {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: @spacing-75;\n    padding: @spacing-100 @spacing-150;\n    background-color: @color-yellow-099;\n    color: @color-yellow-050;\n\n    svg {\n      flex-shrink: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container--uc8Ks`,
	"header": `style__header--UcVZg`,
	"headerInfo": `style__headerInfo--xSziN`,
	"headerSessionName": `style__headerSessionName--ctx91`,
	"icon": `style__icon--EH9ew`,
	"forceStopButton": `style__forceStopButton--qIo4i`,
	"content": `style__content--QUCE0`,
	"tagContainer": `style__tagContainer--njjSg`,
	"avatar": `style__avatar--yISm5`,
	"status": `style__status--HORuB`,
	"inProgressItem": `style__inProgressItem--RnQjK`,
	"caretDown": `style__caretDown--txhsd`,
	"bookmarkItem": `style__bookmarkItem--YmA_3`,
	"errorItem": `style__errorItem--cRNCI`,
	"completeItem": `style__completeItem--MCbZL`,
	"defaultItemIcon": `style__defaultItemIcon--r5XOQ`,
	"box": `style__box--nPfbH`,
	"rating": `style__rating--FjBtv`,
	"highRating": `style__highRating--am6nc`,
	"mediumRating": `style__mediumRating--J7YnD`,
	"lowRating": `style__lowRating--J3lp4`,
	"tooltip": `style__tooltip--fPFPr`,
	"lessonRow": `style__lessonRow--OXwXF`,
	"incidentsBox": `style__incidentsBox--CoXQx`,
	"infoBoxHeader": `style__infoBoxHeader--EjSI6`,
	"emptyIncidents": `style__emptyIncidents--TRuuC`,
	"incidentsList": `style__incidentsList--gfCfG`,
	"incidentItem": `style__incidentItem--bKCXU`,
	"incidentInfo": `style__incidentInfo--AV4Ik`,
	"incidentType": `style__incidentType--QZlss`,
	"incidentDetails": `style__incidentDetails--M7s1d`,
	"incidentThumbnail": `style__incidentThumbnail--HGZia`,
	"playOverlay": `style__playOverlay--JTu8v`,
	"thumbnailPlaceholder": `style__thumbnailPlaceholder--fQ6Vy`,
	"videoDialogOverlay": `style__videoDialogOverlay--YdybS`,
	"videoDialog": `style__videoDialog--wu3Qs`,
	"videoDialogHeader": `style__videoDialogHeader--F5RRG`,
	"closeIcon": `style__closeIcon--_dKb2`,
	"videoDialogContent": `style__videoDialogContent--OQfqB`,
	"videoPlayer": `style__videoPlayer--P1UBR`,
	"videoDialogWarning": `style__videoDialogWarning--XzvmG`
};
export default ___CSS_LOADER_EXPORT___;
